<ion-grid [fixed]="true">
  <ion-row>
    @for (extra of paperExtras(); track extra.id) {
    <ion-col size="12" size-md="6">
      <app-option-selector
        [name]="extra.name"
        [item]="extra"
        [icon]="extra.icon"
        [isSelected]="isSelected(extra)"
        [isDisabled]="isDisabled(extra)"
        (click)="toggleExtra(extra)"
        [isCheckbox]="true">
      </app-option-selector>
    </ion-col>
    } @empty {
    <ion-col size="12">
      <ion-text color="medium">
        <h4>
          {{ "EXTRAS.SELECTION.NO_EXTRAS" | translate }}
        </h4>
      </ion-text>
    </ion-col>
    }
  </ion-row>
  <ion-row *ngIf="selectedPaperExtras().length == 0" class="ion-justify-content-end skip-extras-row">
    <ion-col size="6" class="d-flex ion-justify-content-end">
      <ion-button color="secondary" class="ion-text-end" (click)="skipExtras()">
        {{ "EXTRAS.SKIP_EXTRAS" | translate }}
        <ion-icon name="arrow-forward-circle-outline" color="white"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
